import React from 'react';
import classnames from 'classnames';
import { FiAlertTriangle, FiCheck, FiDisc, FiX } from 'react-icons/fi';
import { getHighlightedClassName } from '../../../util/getHighlightedClassName';

const StepSequencerRow = ({
   pattern,
   referencePattern,
   partsPerBeat,
   onToggle,
   highlightedControls,
   instrumentIndex,
}) =>
   pattern
      .filter((value, partIndex) => partIndex % (partsPerBeat / 4) === 0)
      .map((value, stepIndex) => {
         const partIndex = (stepIndex * partsPerBeat) / 4;
         return (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <button
               // safe to use array index here because the order will never change
               // eslint-disable-next-line react/no-array-index-key
               key={stepIndex}
               type="button"
               onClick={onToggle}
               data-part-index={partIndex}
               className={classnames({
                  selected: value.length > 0,
                  reference: referencePattern?.[partIndex].length > 0,
                  [getHighlightedClassName(
                     highlightedControls[
                        `track:${instrumentIndex}:step:${stepIndex}`
                     ]
                  )]:
                     !!highlightedControls[
                        `track:${instrumentIndex}:step:${stepIndex}`
                     ],
               })}
            >
               <span className="step-icon-wrapper">
                  <FiAlertTriangle size="24" className="missing-icon" />
                  <FiCheck size="24" className="correct-icon" />
                  <FiX size="24" className="incorrect-icon" />
                  <FiDisc size="24" className="selected-icon" />
               </span>
            </button>
         );
      });

export { StepSequencerRow };
